<template>
  <div class="pt-3 px-3">
    <ValidationObserver ref="form" tag="div" class="row">
      <div class="col-12 col-lg-8 pt-2 pt-0-lg">
        <ValidationProvider
          v-slot="{ errors }"
          mode="lazy"
          rules="required"
          :custom-messages="{
            required: 'Favor escriba el nombre del director(a).',
          }"
        >
          <CustomInput
            v-model="model.directorName"
            label="Nombre del Director(a):"
            regular-label
            :disabled="loading"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-lg-4 pt-2">
        <label />
        <div class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end">
          <ActionButton
            text="Cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            class="w-100 w-lg-0"
            @click="cancel"
          />
          <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
          <ActionButton
            text="Guardar"
            variant="success"
            i="fas fa-save"
            class="w-100 w-lg-0"
            :disabled="loading"
            @click="submit"
          />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import alert from '@/mixin/alert.mixin';
import {
  getTapRequestNotification,
  updateDirectorName,
} from '../../../_api.js';

const initialModel = () => ({ directorName: null });

export default {
  name: 'UpdateDirectorName',
  mixins: [alert],
  components: { ActionButton, CustomInput },
  props: {
    tapRequestId: { type: [Number, String], required: true, default: null },
  },
  data: () => ({
    model: initialModel(),
    loading: false,
  }),
  methods: {
    async loadDirectorName() {
      this.loading = true;
      try {
        const { data } = await getTapRequestNotification(this.tapRequestId);
        this.model.directorName = data?.directorName ?? null;
      } catch {
        //
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      const valid = await this.$refs['form'].validate();
      if (!valid) return;

      this.loading = true;
      try {
        await updateDirectorName(this.tapRequestId, {
          directorName: this.model.directorName.trim(),
        });
        this.ShowToast(
          '',
          'El nombre del director(a) ha sido actualizado exitosamente.',
          'success'
        );
        this.cancel(false);
        this.$emit('success');
      } catch (error) {
        this.ShowToast(
          'Error',
          error?.response?.data?.message || 'Ha ocurrido un error inesperado.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    },
    cancel(emit = true) {
      this.model = initialModel();
      this.$refs['form']?.reset();
      if (emit) {
        this.$emit('cancel');
      }
    },
  },
  async created() {
    await this.loadDirectorName();
  },
};
</script>

<style lang="scss" scoped>
.w-lg-0 {
  @media (min-width: 992px) {
    width: inherit !important;
  }
}
</style>
